import { useState, useEffect } from "react";
import { useLocation } from "@tanstack/react-router";
import { motion, AnimatePresence } from "framer-motion";

const PLANK_COUNT = 6;
const PLANK_COLORS = [
  "hsl(28, 50%, 35%)",
  "hsl(30, 55%, 30%)",
  "hsl(25, 45%, 38%)",
  "hsl(32, 52%, 32%)",
  "hsl(27, 48%, 36%)",
  "hsl(30, 50%, 28%)",
];

const PageTransition = () => {
  const { pathname } = useLocation();
  const [isAnimating, setIsAnimating] = useState(false);
  const [prevPath, setPrevPath] = useState(pathname);

  useEffect(() => {
    if (pathname !== prevPath) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setIsAnimating(false);
        setPrevPath(pathname);
      }, 800);
      return () => clearTimeout(timer);
    }
  }, [pathname, prevPath]);

  return (
    <AnimatePresence>
      {isAnimating && (
        <motion.div
          className="fixed inset-0 z-[200] pointer-events-none flex flex-col"
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          {Array.from({ length: PLANK_COUNT }).map((_, i) => (
            <motion.div
              key={i}
              className="flex-1 relative overflow-hidden"
              style={{ backgroundColor: PLANK_COLORS[i % PLANK_COLORS.length] }}
              initial={{ x: i % 2 === 0 ? "-100%" : "100%" }}
              animate={{ x: "0%" }}
              exit={{ x: i % 2 === 0 ? "100%" : "-100%" }}
              transition={{
                duration: 0.35,
                delay: i * 0.04,
                ease: [0.65, 0, 0.35, 1],
              }}
            >
              {/* Wood grain lines */}
              <div
                className="absolute inset-0 opacity-20"
                style={{
                  backgroundImage: `repeating-linear-gradient(
                    90deg,
                    transparent,
                    transparent ${8 + i * 2}px,
                    rgba(0,0,0,0.15) ${8 + i * 2}px,
                    rgba(0,0,0,0.15) ${9 + i * 2}px
                  )`,
                }}
              />
              {/* Subtle highlight edge */}
              <div className="absolute inset-x-0 top-0 h-[1px] bg-white/10" />
              <div className="absolute inset-x-0 bottom-0 h-[1px] bg-black/20" />
            </motion.div>
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PageTransition;
